// import { ChainId } from "@cryption-network/polydex-sdk";
import random from "lodash/random";

declare global {
  interface Window {
    web3: any;
    ethereum: any;
  }
}
// Array of available nodes to connect to
export const nodes = {
  "4": [process.env.REACT_APP_TESTNET_NETWORK_URL],
  "1": [process.env.REACT_APP_NETWORK_URL],
};

const getNodeUrl = () => {
  const chainId = process.env.REACT_APP_CHAIN_ID || "1";
  // @ts-ignore
  const nodesData = nodes[chainId];
  const randomIndex = random(0, nodesData.length - 1);
  return nodesData[randomIndex];
};

export default getNodeUrl;
